module.exports = __webpack_public_path__ + "fafff1f251569f27180d6ecc56aaea4f.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/fontello/fontello.woff2?67495670
// module id = 962
// module chunks = 0